// Table.jsx

import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';
import { useTranslation } from 'react-i18next';

const Table = ({
  title = '',
  data = [],
  columns = [],
  emptyMessageKey = 'no_data_available'
}) => {
  const { t } = useTranslation();
  const tableRef = useRef();

  useEffect(() => {
    const container = d3.select(tableRef.current);
    container.selectAll('*').remove();

    if (!data || data.length === 0) {
      container.append('p').text(t(emptyMessageKey));
      return;
    }

    const table = container.append('table')
      .style('width', '100%')
      .style('border-collapse', 'collapse')
      .style('font-size', '14px');

    const thead = table.append('thead');
    thead.append('tr')
    .selectAll('th')
    .data(columns.map(col => typeof col === 'string' ? col : col.label))
    .enter()
    .append('th')
    .text(d => d) // ✅ AFEGIT: posa el text del capçal
    .style('text-align', 'left')
    .style('padding', '4px')
    .style('border-bottom', '1px solid #ccc')

    const tbody = table.append('tbody');
    data.forEach(row => {
      const tr = tbody.append('tr');
      columns.forEach(col => {
        const key = typeof col === 'string' ? col : col.key;
        tr.append('td')
          .text(row[key])
          .style('padding', '4px')
          .style('border-bottom', '1px solid #eee');
      });
    });
  }, [data, columns, t, emptyMessageKey]);

  return (
    <div className="mt-4">
      {title && <h3 className="text-lg font-medium mb-2">{title}</h3>}
      <div ref={tableRef}></div>
    </div>
  );
};

export default Table;